<template>
  <div class="Search main-container">
    <div class="container">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12">
          <img src="../../static/fw2.png" alt="" />
          <el-button class="btn" type="danger" @click="btn('no')" ref="btn">防伪查询</el-button
          >
        </el-col>
        <el-col :xs="24" :sm="12">
          <img src="../../static/fw1.png" alt="" />
          <el-button class="btn" type="danger" @click="btn">授权查询</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewLiuyanShopWebSearch",
  components: {},
  directives: {},
  data() {
    return {};
  },

  mounted() {},

  methods: {
      btn(is){
        if(is == 'no'){
           this.$router.push({path: '/Security'});
        }else {
             this.$router.push({path: '/Authorization'});
        }
      }
  },
};
</script>

<style lang="less" scoped>
.Search {
  width: 100%;
    display: flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 8%;
    padding-bottom: 10%;
 
    .el-col {
      position: relative;
      padding: 15px 30px !important;
    }
    img {
      width: auto;
      max-width: 100%;
    }

    .btn {
      width: 100%;
      max-width: 200px;
      font-size: 18px;
      color: #fff;
      padding: 5% 4%;
      background: #00383f;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-color:unset!important;
    }
    .btn:hover{
        background:#bb2041!important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Search.vue